import type { ChatsChannelSetting } from '../../../constants';

export const getPrefilledLink = (
  baseLinkObject: ChatsChannelSetting['link'],
  message?: string
) => {
  if (!baseLinkObject?.url) {
    return { url: '' };
  }

  const { url, fallbackUrl } = baseLinkObject;

  const link = new URL(url);

  if (message) {
    link.searchParams.set('text', message);
  }

  let linkObject: { url: string; fallbackUrl?: string } = {
    url: link.toString()
  };

  if (fallbackUrl) {
    const fallbackLink = new URL(fallbackUrl);
    if (message) {
      fallbackLink.searchParams.set('text', message);
    }
    linkObject = { ...linkObject, fallbackUrl: fallbackLink.toString() };
  }

  return linkObject;
};
